import React from 'react'

import VideoDisplay from "../../../scaffolding/Videos"
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Pagination from '@mui/material/Pagination'
import VideoGridItem from "../../../scaffolding/Videos/VideoGridItem"
import {useSearchParams} from 'react-router-dom'
import {useQuery} from "@apollo/client"
import {GET_VIDEOS} from "./graphql"
import Spinner from "../../../global/Spinner"
import {GET_ALL_FAVORITES} from "./graphql"
import Seo from "../../../html/Seo";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


function SearchResults() {

    const [searchParams, setSearchParams] = useSearchParams()

    let query = {}

    searchParams.forEach((value, key) => {
        if (value) {
            query[key] = value
        }
    })

    const created = (searchParams.get('created')) ? searchParams.get('created') : 'desc'

    const {data: videoData, loading: videoLoading, error: videoError} = useQuery(GET_VIDEOS, {
            variables: query,
        }
    )
    const {videoSearch: videos} = videoData ? videoData : {videoFilter: {}}

    const {data: favoritesData} = useQuery(GET_ALL_FAVORITES,
        {
            fetchPolicy: 'no-cache'
        }
    )
    const {getAllFavorites: favorites} = favoritesData ? favoritesData : {getAllFavorites: []}

    const updateSort = (e) => {
        setSearchParams({
            ...query,
            created: e.target.value
        })
    }

    const Page = () => (
        <>
            <Seo title={'Search Results'}/>
            <Grid container sx={{px: {xs: 2}, margin: {md: "auto"}, width: {md: "100%"}}} spacing={4}>
                {videoLoading &&
                    <Spinner/>
                }
                {(videoData && favoritesData && !videoLoading && !videoError) &&
                    <>
                        <Grid item xs={12}>
                            <FormControl>
                                <InputLabel id='created-sort'>Sort:</InputLabel>
                                <Select
                                    labelId='created-sort'
                                    value={created}
                                    onChange={updateSort}
                                    label='Sort'
                                >
                                    <MenuItem value='desc'>Newest First</MenuItem>
                                    <MenuItem value='asc'>Oldest First</MenuItem>

                                </Select>
                            </FormControl>
                        </Grid>
                        {videos.objects.map((video, index) => (
                            <VideoGridItem video={video} index={index} key={`search-result-${index}`}
                                           favoritesData={favorites}/>
                        ))}</>
                }
                {(videoData && !videoLoading && !videoError && videos.pages > 1) &&
                    <Box mt={5} mx={5} sx={{display: "flex", width: "100%"}}>
                        <Pagination sx={{marginLeft: "auto", marginRight: "auto"}}
                                    count={videos.pages}
                                    siblingCount={0}
                                    boundaryCount={1}
                                    defaultPage={videos.page}
                                    onChange={(event, value) => {
                                        searchParams.set('pageNum', value)
                                        setSearchParams(searchParams)
                                    }}
                        />
                    </Box>
                }
            </Grid>
        </>
    )

    return (
        <VideoDisplay>
            <Page/>
        </VideoDisplay>
    )
}

export default SearchResults